// Competition guidelines now live centrally in the WSAP Download Center.
// Every event links there instead of a per-event PDF, so the button always shows.
const WSAP_DOWNLOAD_CENTER_URL =
  "https://bpa.org/member-gateway/wsap-download-center/";

let competitiveEventsDropdownCloseAttached = false;

function closeAllCompetitiveEventDropdowns() {
  document
    .querySelectorAll("[data-wsap-config] .wsap-custom-filter")
    .forEach((filter) => {
      const options = filter.querySelector(".wsap-options");
      const arrow = filter.querySelector(".wsap-arrow");
      if (options) options.style.display = "none";
      if (arrow) arrow.style.transform = "";
    });
}

function initCompetitiveEventBlock(section) {
  let config;
  try {
    config = JSON.parse(section.dataset.wsapConfig || "{}");
  } catch (err) {
    console.error("WSAP Events config parse error:", err);
    const loader = section.querySelector('[id$="-loader"]');
    if (loader) loader.style.display = "none";
    return;
  }

  const BLOCK_ID = config.blockId;
  const areaTermMeta = config.areaTermMeta;
  const PDF_LINK_EXTERNAL = config.pdfLinkExternal;
  const PDF_LINK_LOGIN = config.pdfLinkLogin;
  const IS_USER_LOGGED_IN = !!config.isUserLoggedIn;
  const crossIconUrl = config.crossIconUrl;
  const arrowRightBlackUrl = config.arrowRightBlackUrl;
  const arrowDownWhiteUrl = config.arrowDownWhiteUrl;

  const $ = (id) => document.getElementById(id);

  let allDocs = [];
  let activeAreaSlug = "";
  let activeDivSlug = "";
  let activePartSlug = "";
  let activeFormatSlug = "";
  let searchKeyword = "";
  let openAccordionSlug = null;
  let searchTimer = null;

  function decodeHtml(str) {
    const d = document.createElement("textarea");
    d.innerHTML = str || "";
    return d.value;
  }

  function getPdfLinkHtml() {
    // Always show a "View Guidelines" button pointing at the WSAP Download Center.
    // (Previously this was gated on a per-event pdf_url / login gate, so the button
    // disappeared whenever an event had no PDF set.)
    return PDF_LINK_EXTERNAL.replace("__PDF_URL__", WSAP_DOWNLOAD_CENTER_URL);
  }

  async function fetchAndRender() {
    const loader = $(BLOCK_ID + "-loader");
    if (loader) loader.style.display = "flex";

    try {
      if (
        typeof envConfig === "undefined" ||
        !envConfig.TYPESENSE_BASE_URL?.startsWith("http")
      ) {
        throw new Error("Typesense config is missing.");
      }

      const filters = [];
      if (activeAreaSlug) filters.push(`area_slugs:=[${activeAreaSlug}]`);
      if (activeDivSlug) filters.push(`division_slugs:=[${activeDivSlug}]`);
      if (activePartSlug)
        filters.push(`participation_type_slugs:=[${activePartSlug}]`);
      if (activeFormatSlug)
        filters.push(`event_format_slugs:=[${activeFormatSlug}]`);

      const params = {
        q: searchKeyword.trim() || "*",
        query_by: "searchable_text",
        sort_by: "event_number:asc",
        per_page: 250,
        page: 1,
        num_typos: 1,
        prefix: true,
      };

      if (filters.length) params.filter_by = filters.join(" && ");

      const url =
        `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}/collections/wsap_event/documents/search?` +
        new URLSearchParams(params);

      const res = await fetch(url, {
        headers: {
          "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY,
        },
      });
      if (!res.ok) throw new Error(`Typesense error: ${res.status}`);

      const data = await res.json();
      allDocs = data.hits?.map((h) => h.document) || [];
    } catch (err) {
      console.error("WSAP Events fetch error:", err);
      allDocs = [];
    }

    if (loader) loader.style.display = "none";
    render();
  }

  function renderEventCard(doc) {
    const divisionLabel = (doc.division_names || []).join(", ");
    const hasSponsor = !!doc.sponsor_logo_url;

    const sponsorHtml = hasSponsor
      ? `
        <div class="w-max max-sm:mx-auto lg:h-full px-4 py-2 xsm:py-4 xsm:px-6 rounded-[.3125rem] bg-brand-blue-gray flex flex-col xsm:flex-row items-center justify-center sm:justify-between gap-2 xsm:gap-3 sm:gap-6 sm:flex-shrink-0">
          <p class="text-p1 font-semibold text-brand-dark-blue">${decodeHtml(doc.sponsor_name || "Sponsored by")}</p>
          ${
            doc.sponsor_logo_url
              ? `
            <div class="w-full xsm:w-[.0625rem] h-[.0625rem] xsm:h-full bg-brand-light-sky-blue"></div>
            <div class="w-[11.5rem] h-[4.375rem]">
              <img src="${doc.sponsor_logo_url}" alt="${decodeHtml(doc.sponsor_name || "Sponsor")}"
                class="w-full h-full object-contain object-center">
            </div>`
              : ""
          }
        </div>`
      : "";

    return `
        <div class="wsap-event-card w-full p-4 lg:px-9 lg:py-6 bg-brand-white-smoke flex flex-col items-center sm:items-start gap-2">
          <div class="w-full flex items-center justify-center sm:justify-between flex-wrap gap-2 sm:gap-4 pb-3 border-b border-brand-warm-beige">
            <div class="inline-flex justify-center sm:justify-start gap-2 text-[1.5625rem] leading-[2.0625rem] font-semibold text-brand-dark-blue flex-wrap">
              ${decodeHtml(doc.title || "")}
              ${
                divisionLabel
                  ? `<span class="pl-2 border-l-[.125rem] border-brand-light-sky-blue font-normal">${divisionLabel}</span>`
                  : ""
              }
            </div>
            ${getPdfLinkHtml()}
          </div>
          <div class="w-full flex flex-col md:flex-row items-center md:items-start justify-center md:justify-between gap-2 md:gap-6 lg:gap-10 xl:gap-12">
            <div class="${sponsorHtml ? "w-auto max-w-[41.25rem]" : "w-full"} htmlBlock htmlBlock-para-style">
              ${doc.text || ""}
            </div>
            ${sponsorHtml}
          </div>
        </div>`;
  }

  function render() {
    const container = $(BLOCK_ID + "-accordion-container");
    container.innerHTML = "";

    // When a search keyword or any filter is active, auto-expand every
    // matching accordion so the results show without an extra click.
    const hasActiveFilter = !!(
      searchKeyword ||
      activeAreaSlug ||
      activeDivSlug ||
      activePartSlug ||
      activeFormatSlug
    );

    let totalVisible = 0;

    const docsByAreaSlug = {};
    allDocs.forEach((doc) => {
      (doc.area_slugs || []).forEach((slug) => {
        if (!docsByAreaSlug[slug]) docsByAreaSlug[slug] = [];
        docsByAreaSlug[slug].push(doc);
      });
    });

    areaTermMeta.forEach((area) => {
      const areaDocs = docsByAreaSlug[area.slug] || [];
      if (areaDocs.length === 0) return;
      totalVisible += areaDocs.length;

      const isOpen = hasActiveFilter ? true : openAccordionSlug === area.slug;

      const wrapper = document.createElement("div");
      wrapper.className = "wsap-accordion w-full flex flex-col";
      wrapper.dataset.areaSlug = area.slug;

      const closedHeader = document.createElement("div");
      closedHeader.className = [
        "wsap-trigger-closed w-full grid grid-cols-1",
        area.image_url ? "sm:grid-cols-[11.4rem_auto]" : "",
        "border border-brand-warm-gray transition-transform duration-300 ease-in-out hover:scale-[1.01] cursor-pointer",
        isOpen ? "hidden" : "",
      ].join(" ");
      closedHeader.innerHTML = `
          ${
            area.image_url
              ? `
            <div class="w-full relative !h-[17rem] sm:!h-full bg-brand-light-blue">
              <img src="${area.image_url}" alt="${area.image_alt || area.name}"
                class="sm:absolute !inset-0 object-contain sm:object-cover object-center w-full !h-full">
            </div>`
              : ""
          }
          <div class="w-full max-sm:p-5 sm:p-6 lg:!pl-10 xl:!pl-12 lg:!py-10 h-auto ${area.image_url ? "min-h-[7rem] sm:min-h-[11.4rem]" : "min-h-[7rem]"} flex items-center justify-between gap-2 sm:gap-4 lg:gap-8 bg-brand-white-smoke">
            <div class="flex flex-col items-start gap-2">
              <h3 class="text-[1.5625rem] leading-[2.0625rem] text-brand-dark-blue font-semibold">${area.name}</h3>
              ${area.description ? `<div class="htmlBlock text-brand-black"><p>${area.description}</p></div>` : ""}
            </div>
            <img src="${arrowRightBlackUrl}" alt="expand" class="w-7 h-7 object-contain flex-shrink-0">
          </div>`;

      const openHeader = document.createElement("div");
      openHeader.className = [
        "wsap-trigger-open w-full grid grid-cols-1",
        area.image_url ? "sm:grid-cols-[11.4rem_auto]" : "",
        "cursor-pointer",
        isOpen ? "" : "hidden",
      ].join(" ");
      openHeader.innerHTML = `
          ${
            area.image_url
              ? `
            <div class="w-full relative !h-[17rem] sm:!h-full bg-brand-light-blue">
              <img src="${area.image_url}" alt="${area.image_alt || area.name}"
                class="sm:absolute !inset-0 object-contain sm:object-cover object-center w-full !h-full">
            </div>`
              : ""
          }
          <div class="w-full max-sm:p-5 sm:p-6 lg:!pl-10 xl:!pl-12 lg:!py-10 h-auto ${area.image_url ? "min-h-[7rem] sm:min-h-[11.4rem]" : "min-h-[7rem]"} flex items-center justify-between gap-2 sm:gap-4 lg:gap-8 bg-brand-dark-red">
            <div class="flex flex-col items-start gap-2">
              <h3 class="text-[1.5625rem] leading-[2.0625rem] text-white font-semibold">${area.name}</h3>
              ${area.description ? `<div class="htmlBlock text-white"><p>${area.description}</p></div>` : ""}
            </div>
            <img src="${arrowDownWhiteUrl}" alt="close" class="w-7 h-7 object-contain flex-shrink-0">
          </div>`;

      const content = document.createElement("div");
      content.className =
        "wsap-accordion-content w-full !border-t-[0.5rem] !border-t-brand-warm-beige border border-brand-warm-gray p-4 lg:p-9 flex flex-col gap-4 lg:gap-6 overflow-hidden";
      content.style.cssText = isOpen
        ? "max-height: 10000px; opacity: 1; transition: max-height 0.5s ease-in-out, opacity 0.4s ease-in-out;"
        : "max-height: 0; opacity: 0; padding-top: 0; padding-bottom: 0; border-width: 0; transition: max-height 0.4s ease-in-out, opacity 0.3s ease-in-out;";
      content.innerHTML = areaDocs.map(renderEventCard).join("");

      function toggleAccordion() {
        // Derive current state from the DOM so this works whether one
        // accordion is open (normal browsing) or several are open at once
        // (auto-expanded by an active search/filter).
        const isCurrentlyOpen = !openHeader.classList.contains("hidden");
        const willOpen = !isCurrentlyOpen;
        openAccordionSlug = willOpen ? area.slug : null;

        closedHeader.classList.toggle("hidden", willOpen);
        openHeader.classList.toggle("hidden", !willOpen);

        if (willOpen) {
          content.style.maxHeight = "10000px";
          content.style.opacity = "1";
          content.style.paddingTop = "";
          content.style.paddingBottom = "";
          content.style.borderWidth = "";

          const offset = window.innerWidth >= 1024 ? 60 : 30;
          const top =
            wrapper.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: "smooth" });
        } else {
          content.style.maxHeight = "0";
          content.style.opacity = "0";
          content.style.paddingTop = "0";
          content.style.paddingBottom = "0";
          content.style.borderWidth = "0";
        }

        // Single-open behaviour only applies during normal browsing. When a
        // search/filter is active multiple accordions are open, so leave the
        // others alone.
        if (!hasActiveFilter) {
          container.querySelectorAll(".wsap-accordion").forEach((acc) => {
            if (acc === wrapper) return;
            acc
              .querySelector(".wsap-trigger-closed")
              ?.classList.remove("hidden");
            acc.querySelector(".wsap-trigger-open")?.classList.add("hidden");
            const c = acc.querySelector(".wsap-accordion-content");
            if (c) {
              c.style.maxHeight = "0";
              c.style.opacity = "0";
              c.style.paddingTop = "0";
              c.style.paddingBottom = "0";
              c.style.borderWidth = "0";
            }
          });
        }
      }

      closedHeader.addEventListener("click", toggleAccordion);
      openHeader.addEventListener("click", toggleAccordion);

      wrapper.appendChild(closedHeader);
      wrapper.appendChild(openHeader);
      wrapper.appendChild(content);
      container.appendChild(wrapper);
    });

    const countEl = $(BLOCK_ID + "-results-count");
    if (
      searchKeyword ||
      activeAreaSlug ||
      activeDivSlug ||
      activePartSlug ||
      activeFormatSlug
    ) {
      countEl.textContent = `${totalVisible} Result${totalVisible !== 1 ? "s" : ""}`;
      countEl.classList.remove("hidden");
    } else {
      countEl.classList.add("hidden");
    }

    updateFilterPills();
  }

  function updateFilterPills() {
    const pillsEl = $(BLOCK_ID + "-chips-wrapper");
    const filtersEl = $(BLOCK_ID + "-chip-container");
    pillsEl.innerHTML = "";

    const pills = [];

    if (searchKeyword) {
      pills.push({
        label: searchKeyword,
        clear() {
          searchKeyword = "";
          $(BLOCK_ID + "-search-input").value = "";
        },
      });
    }
    if (activeAreaSlug) {
      const name =
        areaTermMeta.find((a) => a.slug === activeAreaSlug)?.name ||
        activeAreaSlug;
      pills.push({
        label: `${name}`,
        clear() {
          activeAreaSlug = "";
          const el = $(BLOCK_ID + "-area-select")?.querySelector(
            ".selected-text",
          );
          if (el) el.textContent = "Filter by Areas";
        },
      });
    }
    if (activeDivSlug) {
      const li = $(BLOCK_ID + "-division-select")?.querySelector(
        `[data-value="${activeDivSlug}"]`,
      );
      const name = li ? li.textContent.trim() : activeDivSlug;
      pills.push({
        label: `Division: ${name}`,
        clear() {
          activeDivSlug = "";
          const el = $(BLOCK_ID + "-division-select")?.querySelector(
            ".selected-text",
          );
          if (el) el.textContent = "Filter by Division";
        },
      });
    }
    if (activePartSlug) {
      const li = $(BLOCK_ID + "-participation-select")?.querySelector(
        `[data-value="${activePartSlug}"]`,
      );
      const name = li ? li.textContent.trim() : activePartSlug;
      pills.push({
        label: `Participation: ${name}`,
        clear() {
          activePartSlug = "";
          const el = $(BLOCK_ID + "-participation-select")?.querySelector(
            ".selected-text",
          );
          if (el) el.textContent = "Filter by Participation Type";
        },
      });
    }
    if (activeFormatSlug) {
      const li = $(BLOCK_ID + "-format-select")?.querySelector(
        `[data-value="${activeFormatSlug}"]`,
      );
      const name = li ? li.textContent.trim() : activeFormatSlug;
      pills.push({
        label: `Format: ${name}`,
        clear() {
          activeFormatSlug = "";
          const el = $(BLOCK_ID + "-format-select")?.querySelector(
            ".selected-text",
          );
          if (el) el.textContent = "Filter by Event Format";
        },
      });
    }

    if (pills.length > 0) {
      filtersEl.classList.remove("hidden");
      pills.forEach(({ label, clear }) => {
        const pill = document.createElement("span");
        pill.className =
          "inline-flex items-center gap-[.625rem] bg-brand-dark-red text-white font-neutraface text-p1 p-2 !pl-6 rounded-full cursor-pointer";
        pill.innerHTML = `${label} <div class="w-[1.875rem] h-[1.875rem]">
            <img src="${crossIconUrl}" alt="close" class="w-full h-full">
          </div>`;
        pill.addEventListener("click", () => {
          clear();
          openAccordionSlug = null;
          fetchAndRender();
        });
        pillsEl.appendChild(pill);
      });
    } else {
      filtersEl.classList.add("hidden");
    }
  }

  function closeAllDropdowns() {
    section.querySelectorAll(".wsap-custom-filter").forEach((f) => {
      f.querySelector(".wsap-options").style.display = "none";
      f.querySelector(".wsap-arrow").style.transform = "";
    });
  }

  function initDropdowns() {
    section.querySelectorAll(".wsap-custom-filter").forEach((filter) => {
      const display = filter.querySelector(".wsap-select-display");
      const optsList = filter.querySelector(".wsap-options");
      const arrow = filter.querySelector(".wsap-arrow");
      const selText = filter.querySelector(".selected-text");

      optsList.style.display = "none";

      display.addEventListener("click", (e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();

        const isVisible = optsList.style.display === "block";

        closeAllDropdowns();

        if (!isVisible) {
          optsList.style.display = "block";
          arrow.style.transform = "rotate(180deg)";
        }
      });

      optsList.addEventListener("click", (e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();
      });

      optsList.querySelectorAll("li").forEach((li) => {
        li.addEventListener("click", (e) => {
          e.stopPropagation();
          selText.textContent = li.textContent.trim();
          optsList.style.display = "none";
          arrow.style.transform = "";

          if (filter.id === BLOCK_ID + "-area-select") {
            activeAreaSlug = li.dataset.value;
          } else if (filter.id === BLOCK_ID + "-division-select") {
            activeDivSlug = li.dataset.value;
          } else if (filter.id === BLOCK_ID + "-participation-select") {
            activePartSlug = li.dataset.value;
          } else if (filter.id === BLOCK_ID + "-format-select") {
            activeFormatSlug = li.dataset.value;
          }
          openAccordionSlug = null;
          fetchAndRender();
        });
      });
    });
  }

  function initSearch() {
    $(BLOCK_ID + "-search-input")?.addEventListener("input", (e) => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        searchKeyword = e.target.value;
        openAccordionSlug = null;
        fetchAndRender();
      }, 400);
    });
  }

  function initClearFilters() {
    $(BLOCK_ID + "-clear-all")?.addEventListener("click", (e) => {
      e.preventDefault();
      searchKeyword = "";
      activeAreaSlug = "";
      activeDivSlug = "";
      activePartSlug = "";
      activeFormatSlug = "";
      openAccordionSlug = null;

      const inp = $(BLOCK_ID + "-search-input");
      if (inp) inp.value = "";

      const areaText = $(BLOCK_ID + "-area-select")?.querySelector(
        ".selected-text",
      );
      if (areaText) areaText.textContent = "Filter by Areas";

      const divText = $(BLOCK_ID + "-division-select")?.querySelector(
        ".selected-text",
      );
      if (divText) divText.textContent = "Filter by Division";

      const partText = $(BLOCK_ID + "-participation-select")?.querySelector(
        ".selected-text",
      );
      if (partText) partText.textContent = "Filter by Participation Type";

      const formatText = $(BLOCK_ID + "-format-select")?.querySelector(
        ".selected-text",
      );
      if (formatText) formatText.textContent = "Filter by Event Format";

      fetchAndRender();
    });
  }

  initDropdowns();
  initSearch();
  initClearFilters();
  fetchAndRender();
}

function initCompetitiveEventListings() {
  if (!competitiveEventsDropdownCloseAttached) {
    competitiveEventsDropdownCloseAttached = true;
    document.addEventListener("click", closeAllCompetitiveEventDropdowns);
  }

  document
    .querySelectorAll("[data-wsap-config]:not([data-wsap-initialized])")
    .forEach((section) => {
      section.dataset.wsapInitialized = "true";
      initCompetitiveEventBlock(section);
    });
}

window.initCompetitiveEventListings = initCompetitiveEventListings;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCompetitiveEventListings);
} else {
  initCompetitiveEventListings();
}

document.addEventListener("ajax:loaded", initCompetitiveEventListings);
